export default __webpack_public_path__ + "static/media/celestialart.93cd4187.webp";